import React from 'react'

import { formManagerReducer, initialState } from './FormManagerReducer'

const FormManagerContext = React.createContext()

const FormManagerContextProvider = (props) => {
  const [state, dispatch] = React.useReducer(formManagerReducer, initialState)
  const value = React.useMemo(() => [state, dispatch], [state])

  return <FormManagerContext.Provider value={value} {...props} />
}

const useFormManagerContext = () => {
  const context = React.useContext(FormManagerContext)

  if (!context) {
    throw new Error('useFormManagerContext must be used within a FormManagerContextProvider')
  }

  const [state, dispatch] = context

  const setUserFormData = (userFormData) => {
    dispatch({ type: 'SET_USERFORMDATA', userFormData: userFormData })
  }

  const setFormsData = (formsData) => {
    dispatch({ type: 'SET_FORMSDATA', formsData: formsData })
  }

  return {
    ...state,
    dispatch,
    setUserFormData,
    setFormsData,
  }
}

export { FormManagerContext, FormManagerContextProvider, useFormManagerContext }
